// ABOUTME: The mobile scrim behind an open bag / favourites / privacy panel — dims and blurs the reel
// ABOUTME: overlays (PDP sheet, tags, cards) so the panel reads alone; a tap on it closes the panel.

import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import OverlayPortal from '../Projectionist/overlays/OverlayPortal';

// Owner report 2026-10-13: the panel's own 50% fill + 13px blur only covers its footprint, so a PDP
// running on below the panel's edge read as a second card stacked under it. This layer covers the
// whole frame instead.
// Z: above the stage overlays (62) and the stage fade (63), below the footer / mic portal (65) so
// the guest can still talk to the concierge with the bag open, and below the chrome portal (80) that
// carries the panel and chips. It shares 64 with the Views toggle (top-left, under the panel's own
// footprint): mounting on open appends this portal after it, so the tie goes to the scrim.
export const MOBILE_PANEL_SCRIM_Z = 64;
export const MOBILE_PANEL_SCRIM_BG = 'rgba(0,0,0,0.55)';

/**
 * @param {{ open: boolean, onDismiss: () => void, reducedMotion?: boolean }} props
 */
function MobilePanelScrim({ open, onDismiss, reducedMotion = false }) {
  // Client-only: the server renderer has no portals, and the panel-width suites render the chrome
  // with renderToStaticMarkup. The chrome mounts long before any panel opens, so this costs no frame.
  const [mounted, setMounted] = useState(false);
  useEffect(() => { setMounted(true); }, []);
  if (!mounted) return null;
  return (
    // The portal itself mounts on open (not with the chrome) so it is appended after the Views
    // toggle's; AnimatePresence still plays the nested motion child's exit before unmounting it.
    // `initial={false}` as MobileChrome's own: a panel already open on mount shows its scrim at once.
    <AnimatePresence initial={false}>
      {open && (
        <OverlayPortal key="mobile-panel-scrim" zIndex={MOBILE_PANEL_SCRIM_Z}>
          <motion.div
            data-testid="mobile-panel-scrim"
            aria-hidden="true"
            // The panel's own blur token, so the frame and the panel go soft by the same amount.
            className="backdrop-blur-reel-chrome"
            onClick={onDismiss}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={reducedMotion ? { duration: 0 } : { duration: 0.28, ease: [0.4, 0, 0.2, 1] }}
            style={{
              position: 'absolute',
              inset: 0,
              pointerEvents: 'auto',
              background: MOBILE_PANEL_SCRIM_BG,
            }}
          />
        </OverlayPortal>
      )}
    </AnimatePresence>
  );
}

export default MobilePanelScrim;
